<template lang="pug">
  .app-container
    front-menu
    main.app-content
      section.hero.is-bold.is-primary.is-medium
        .hero-body.mb-4
          .container.is-flex-column
            .is-order-3
              h1.title.has-text-left.mt-4 Explore the most-used words in English
              .box.px-0.py-2
                list
            .is-order-2
              h2.title.has-text-left Filter the list on <strong>part of speech</strong>, <strong>phonemes</strong>, <strong>stress patterns</strong>...
              filters
            .is-order-1.pb-4(
              v-if="!videoSeen"
              @click="goFullScreen"
            )
              .has-position-relative.is-inline-block
                iframe(
                  ref="demoVideo"
                  src="https://player.vimeo.com/video/327314075"
                  width="640"
                  height="376"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen)
                .button.button-close.is-rounded.is-dark(@click="toggleVideoSeen")
                  b-icon(icon="close")

            youtube-player

      partner-footer
</template>

<script>
  import { nodeApi } from "@/config";
  import list from "@/components/ListV2";
  import partnerFooter from "@/components/PartnerFooter";
  import filters from "@/components/Filters";
  import youtubePlayer from "@/components/YoutubePlayer";
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "ListPage",
    components: {
      list,
      filters,
      partnerFooter,
      youtubePlayer
    },
    computed: mapGetters(['videoSeen']),
    data() {
      return {
      };
    },
    created() {
    },
    methods: {
      ...mapActions(['toggleVideoSeen']),
      goFullScreen() {
        const {demoVideo} = this.$refs.demoVideo;
        const method =
          demoVideo.requestFullscreen ||
          demoVideo.webkitRequestFullscreen ||
          demoVideo.mozRequestFullScreen ||
          demoVideo.msRequestFullscreen;
        console.log({method});
        method();
      }

    }
  };
</script>

<style lang="scss" scoped>
  @import "colors";

  .is-green {
    color: $green;
  }
  .is-red {
    color: $red;
  }

  .is-order-1 {
    order: 1
  }
  .is-order-2 {
    order: 2
  }
  .is-order-3 {
    order: 3
  }

  .button-close {
    min-width: 20px;
    width: 36px;
    position: absolute;
    top: -16px;
    right: -19px;
  }

  @media screen and (max-width: 768px) {
    iframe {
      max-width: 100%;
      height: auto;
    }
  }

</style>





// WEBPACK FOOTER //
// src/components/ListPage.vue